import { Alert, Snackbar, Slide } from "@mui/material";
import React, { useState, useEffect } from 'react';

function Transition(props) {
  return <Slide {...props} direction="down" />;
}

function getDisplayMessage(message) {
  if (React.isValidElement(message)) {
    return message;
  }

  if (message == null) {
    return "";
  }

  if (typeof message === "string" || typeof message === "number") {
    return message;
  }

  if (message instanceof Error) {
    return message.message;
  }

  if (typeof message === "object") {
    if (typeof message.message === "string") {
      return message.message;
    }

    if (typeof message.error === "string") {
      return message.error;
    }

    try {
      return JSON.stringify(message);
    } catch {
      return "Unexpected error";
    }
  }

  return String(message);
}

function StatusSnackbar({ setSnackbarOpen, openState, message, severity, autoHideDuration }) {
  const [open, setOpen] = useState(openState);
  const displayMessage = getDisplayMessage(message);

  useEffect(() => {
    setOpen(openState);
  }, [openState]);

  const handleClose = (event) => {
    // do not close snackbar if user clicks away
    if (event && !document.getElementById('status-snackbar').contains(event.target)) {
      return;
    }
    setOpen(false);
    setSnackbarOpen(false);
  };

  // Function to render message
  const renderMessage = () => {
    // Check if message is a React component
    if (React.isValidElement(displayMessage)) {
      return displayMessage;
    }
    // If message is a string
    return <span>{displayMessage}</span>;
  };

  return (
    <Snackbar
      id="status-snackbar"
      data-testid="status-snackbar"
      open={open}
      TransitionComponent={Transition}
      message={React.isValidElement(displayMessage) ? undefined : displayMessage}
      autoHideDuration={autoHideDuration}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
      <Alert onClose={handleClose} severity={severity} sx={{ width: '100%' }}>
        {renderMessage()} {/* Render message based on its type */}
      </Alert>
    </Snackbar>
  );
}

export default StatusSnackbar;
